<template>
  <div>
    <br/>
    <h5 class="pageTitle">Faire un don</h5>

    <div>
      <p>
        Paraplumes est l'image du fonds du Club des ornithologues de Québec pour la protection des oiseaux. L’objectif du fonds est de
        recueillir des dons de nos membres ou de non-membres afin d’appuyer différentes initiatives de nos partenaires dans les dossiers ayant trait
        à la protection des oiseaux du Québec et de leurs habitats.
      </p>
      <p>
        Le logo de Paraplumes montre une coquille d’œuf qui inspire la forme d’un parapluie assurant ainsi une protection au parent et à son oisillon
        d’où le slogan qui en découle : …Y contribuer c’est permettre aux petits de devenir grands !
      </p>
    </div>

    <form-don/>

    <div style="text-align: center">
      <img :src="require('../assets/images/paraplume.jpg')" style="max-width: 700px"/>
    </div>

    <br/>
  </div>
</template>

<script>
  import FormDon from '../components/Dons/Don_Formulaire';
  export default {
    name: 'FaireDon',
    components: {
      FormDon
    }
  };
</script>

<style scoped></style>
